require('./brokerHireAlternativeInvestmentFundStep2.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const { FormattedText, formatText } = require('core/i18n').i18n;
const Immutable = require('immutable');

// @ actions
const investmentFundsActions = require('actions/investmentFunds');
const brokerLegalDocumentationActions = require('actions/brokerLegalDocumentation');

// @ commons
const { OKMessage } = require('commonsComponents/OKMessage');

// @ components
const { OKConsents } = require('gdpr-consents/components/OKConsents/OKConsents.js');
const ExtantCostDetails = require('components/broker/brokerHireAlternativeInvestment/brokerHireAlternativeInvestmentFundStep2/components/extantCostDetails');
const { GDPRSignaturePattern } = require('components/gdprSignaturePattern/gdprSignaturePattern');
const BrokerHireAlternativeInvestmentFundDetails = require('../brokerHireAlternativeInvestmentFundDetails/brokerHireAlternativeInvestmentFundDetails');
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING, CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { BrokerFundLegalDocumentDisclaimer } = require('../../brokerFundLegalDocumentDisclaimer/brokerFundLegalDocumentDisclaimer');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const WebappRender = require('components/conditionalRender/webappRender');
import BrokerLegalDocumentation from 'components/broker/brokerLegalDocumentation/brokerLegalDocumentation';

// @ constants
const {
    API_ENTERPRISE_NUMBER,
    API_CENTER,
    FIRST_STEP,
    SECOND_STEP,
    BROKER_GREEN_FUND,
    BROKER_YELLOW_FUND,
    BROKER_MIFID_FUND_GREEN,
    BROKER_MIFID_FUND_YELLOW,
    BROKER_MIFID_VERSION_1,
    BROKER_PRODUCT_TYPE_ALTERNATIVE_FUNDS,
} = require('constants/index');

const {
    BROKER_HIRE_INVESTMENT_FUND_ID,
    BROKER_ADD_SUBSCRIPTION_INVESTMENT_FUND_ID,
    messages: {BROKER_HIRE_INVESTMENT_FUND_AND_GDPR}
} = require('constants/operationTypes');

const { HIRE_INITIAL_FUNDS_GDPR_PID } = require('constants/gdprPlacementIds');

// @ helpers
const { getFormattedString } = require('utilities/currencyHelper');
const { PROC_BROKER_FUNDS_PG_NAME, recordLinkV2, recordPage } = require('utilities/tagging.js')
class BrokerHireAlternativeInvestmentFundStep2 extends React.Component {
    constructor(props) {
        super(props);

        this.buildDisclaimerCheckbox = this.buildDisclaimerCheckbox.bind(this);
        this.handleReadCheckChange = this.handleReadCheckChange.bind(this);
        this.buildMifidDisclaimer = this.buildMifidDisclaimer.bind(this);

        this.state = {
            allowClickDisclaimer: false,
            showDisclaimerErrorState: false
        }
    }

    componentDidMount() {
        const {
            history,
            immInvestmentFunds,
            fundId,
            postPreHire,
            immFlagBasedFeatures,
            immAccounts,
            extantDataFetch,
            tealiumData,
        } = this.props;

        const isSubscription = immInvestmentFunds.getIn(['steps', 0, 'isSubscription']);
        const contractNumber = immInvestmentFunds.getIn([
            'steps',
            1,
            'contractFund',
            'contractNumber'
        ]);
        if (!isSubscription && !!!contractNumber) {
            const featureFlagShowExtantCostBuyFunds = immFlagBasedFeatures.get("wealth_funds_buy_show_costs");
            postPreHire(fundId, featureFlagShowExtantCostBuyFunds, history);
        }

        const isin = immInvestmentFunds.getIn(['investmentFunds', 'isin'])
        const amount = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'amount']);
        const accountNumber = immInvestmentFunds.getIn(['steps', 0, 'accountNumber']);
        const immAccount = immAccounts.get(accountNumber);
        const currency = immAccount.getIn(['balance', 'currency']);
        const featureFlagShowExantCostBuyFunds = immFlagBasedFeatures.get("wealth_funds_buy_show_costs");

        if (
            immInvestmentFunds.get('fetchingDataExt') === false &&
            !immInvestmentFunds.get("fetchDataExtError") &&
            currency !== null &&
            isSubscription &&
            featureFlagShowExantCostBuyFunds
            ) {
                const query = {
                    importe: {
                        amount: amount,
                        currency: currency
                    },
                    isin: isin
                };
                extantDataFetch(query, history);
            }
        recordPage(tealiumData[0]);
        recordLinkV2(tealiumData[1]);
        this.props.onStepChange('step 2')
    }

    componentWillUnmount() {
        this.props.resetFetchedPre();
        this.props.removeLegalDocumentation();
        this.props.handleChangeReadChecked(false);
    }

    buildColumns() {
        const { immInvestmentFunds } = this.props;
        const isSubscription = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'isSubscription']);
        if (isSubscription) {
            return [
                'brokerAlternativeFundsBuyStep2-destinationSubs',
                'account',
                'brokerAlternativeFundsBuyStep2-amountSubs',
                'brokerAlternativeFundsBuyStep2-lastValue'
            ];
        } else {
            return [
                'brokerAlternativeFundsBuyStep2-destination',
                'account',
                'brokerAlternativeFundsBuyStep2-amount'
            ];
        }
    }

    buildDetailsColumns() {
        const { immInvestmentFunds, immAccounts, immFlagBasedFeatures, immBrokerMyInvestments } = this.props;

        const fundName = immInvestmentFunds.getIn(['steps', 0, 'investmentFunds', 'name']);
        const accountNumber = immInvestmentFunds.getIn(['steps', 0, 'accountNumber']);
        const immAccount = immAccounts.get(accountNumber);
        const currencyObject = Immutable.Map().merge({
            amount: immInvestmentFunds.getIn(['steps', 0, 'amount']),
            currency: immAccount.getIn(['balance', 'currency'])
        });
        const amountInvestment = getFormattedString(currencyObject);

        let columnsContent = [fundName, 'account', amountInvestment];
        const isSubscription = immInvestmentFunds.getIn(['steps', 0, 'isSubscription']);
        if (isSubscription) {
            const liquidAmount = immInvestmentFunds.getIn(['investmentFunds', 'netAssetValue']);
            const liquidAmountText = getFormattedString(liquidAmount);
            columnsContent.push(liquidAmountText);
        }
        const columns = this.buildColumns();

        const featureFlagShowExtantCostBuyFunds = immFlagBasedFeatures.get('wealth_funds_buy_show_costs');

        if (featureFlagShowExtantCostBuyFunds) {
            return (
                <ExtantCostDetails
                    immInvestmentFunds={immInvestmentFunds}
                    immAccount={immAccount}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    immBrokerMyInvestments={immBrokerMyInvestments}
                />
            )
        } else {
            return (
                <BrokerHireAlternativeInvestmentFundDetails
                    columns={columns}
                    columnsContent={columnsContent}
                    immAccount={immAccount}
                    immInvestmentFunds={immInvestmentFunds}
                />
            );
        }
    }

    buildDisclaimerCheckbox() {
        const { immInvestmentFunds, immFlagBasedFeatures } = this.props;
        const { showDisclaimerErrorState } = this.state

        const showDetailsCost = immFlagBasedFeatures.get("wealth_funds_buy_show_costs");

        const fundName = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'name']);
        const fundIsin = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'isin']);
        const fundSecId = immInvestmentFunds.getIn([
            'steps',
            FIRST_STEP,
            'investmentFunds',
            'secId'
        ]);
        const isSpanish = (fundIsin + '').slice(0, 2).toLowerCase() === 'es';
        const checked = immInvestmentFunds.getIn(['steps', SECOND_STEP, 'readChecked']);

        return (
            <div className="hire-alternative-investment-step2__declaration-text">
                <BrokerFundLegalDocumentDisclaimer
                    disclaimerErrorState={showDisclaimerErrorState}
                    disclaimerErrorMessage={formatText('brokerAlternativeFundsBuyStep2-checkError')}
                    disclaimerChecked={checked}
                    onDisclaimerCheckChange={this.handleReadCheckChange}
                    isSpanish={isSpanish}
                    fundName={fundName}
                    fundIsin={fundIsin}
                    fundSecId={fundSecId}
                    enableTransactionCost={!showDetailsCost}
                    isAlternativeFund={true}
                />
            </div>
        );
    }

    buildInfoSubs() {
        const { immInvestmentFunds } = this.props;
        const isSubscription = immInvestmentFunds.getIn(['steps', 0, 'isSubscription']);
        if (isSubscription) {
            return (
                <OKMessage type="informative">
                    <FormattedText value="brokerAlternativeFundsBuyStep2-info" />
                </OKMessage>
            );
        }
    }


    buildMifidDisclaimer() {
        const { immBrokerConvenienceMiFIDTest, immBrokerMiFIDProducts, immInvestmentFunds } = this.props;
        const usingMifidv1 = immBrokerConvenienceMiFIDTest.get('mifidVersion') === BROKER_MIFID_VERSION_1;

        if (usingMifidv1) {
            const fundType = immInvestmentFunds.getIn([
                'steps',
                FIRST_STEP,
                'investmentFunds',
                'customCategoryId3'
            ]);

            if (fundType === BROKER_YELLOW_FUND || fundType === BROKER_GREEN_FUND) {
                const fundMifidId =
                    fundType === BROKER_YELLOW_FUND
                        ? BROKER_MIFID_FUND_YELLOW
                        : BROKER_MIFID_FUND_GREEN;

                if (immBrokerMiFIDProducts.getIn(['products', fundMifidId, 'loading'])) {
                    return <LoadingSection />;
                } else {
                    const mifidDisclaimer = immBrokerMiFIDProducts.getIn([
                        'products',
                        fundMifidId,
                        'disclaimer'
                    ]);

                    return (
                        <div className="hire-alternative-investment-step2__mifid-disclaimer">
                            <OKMessage type="informative">
                                {mifidDisclaimer}
                            </OKMessage>
                        </div>
                    );
                }
            }
        }
    }

    handleReadCheckChange(ev) {
        const { handleChangeReadChecked, immLegalDocumentationProduct, immInvestmentFunds } = this.props
        let documentsForRead=0;
        const fundIsin = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'isin']);
        const listDocuments = immLegalDocumentationProduct.getIn(['boxes',fundIsin, 'documents'])
        if (!!listDocuments) {
            listDocuments.map((doc) => {
                const immDoc = doc.toJS();
                immDoc.read === false && documentsForRead++;

            })
        }

        const { allowClickDisclaimer } = this.state
        if(allowClickDisclaimer && documentsForRead === 0) {
            this.setState({ showDisclaimerErrorState: false })
            handleChangeReadChecked(ev.target.checked)
        }else {
            this.setState({ showDisclaimerErrorState: true })
        }
    }

    renderDocumentationBox = () => {
        const { immInvestmentFunds, immFlagBasedFeatures } = this.props;
        if (immInvestmentFunds.get('fetchingDocumentsValidate')) {
            return null;
        }

        const showDetailsCost = immFlagBasedFeatures.get("wealth_funds_buy_show_costs");

        const fundName = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'name']);
        const fundIsin = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'isin']);
        const fundSecId = immInvestmentFunds.getIn([
            'steps',
            FIRST_STEP,
            'investmentFunds',
            'secId'
        ]);
        const enableEconomicReport = immInvestmentFunds.get('enableEconomicReport');

        return (
            <BrokerLegalDocumentation
                className="hire-alternative-investment-step2__documentation-box"
                isin={fundIsin}
                secId={fundSecId}
                productDefinition={fundName}
                productType={BROKER_PRODUCT_TYPE_ALTERNATIVE_FUNDS}
                reportCompleted={() => this.setState({ allowClickDisclaimer: true })}
                enableTransactionCost={!showDetailsCost}
                pageName={PROC_BROKER_FUNDS_PG_NAME}
                enableEconomicReport={enableEconomicReport}
            />
        );
    }

    render() {
        const { immInvestmentFunds, immAccounts, immFlagBasedFeatures  } = this.props;
        const { showDisclaimerErrorState } = this.state
        const showGDPRSignaturePattern = __CONTACT_CENTER__ ? true : immInvestmentFunds.getIn(['steps', SECOND_STEP, 'readChecked']);
        const featureFlagShowExtantCostBuyFunds = immFlagBasedFeatures.get("wealth_funds_buy_show_costs");
        const accountNumber = immInvestmentFunds.getIn(['steps', 0, 'accountNumber']);
        const immAccount = immAccounts.get(accountNumber);
        const columnsContainer = this.buildDetailsColumns();
        const mifidDisclaimer = this.buildMifidDisclaimer();
        const infoLabel = this.buildInfoSubs();
        let operationParams;
        const isSubscription = immInvestmentFunds.getIn(['steps', 0, 'isSubscription']);
        const trxId = isSubscription
            ? BROKER_ADD_SUBSCRIPTION_INVESTMENT_FUND_ID
            : BROKER_HIRE_INVESTMENT_FUND_ID;
        const productNumber = immInvestmentFunds.getIn(['contractFund', 'product']);
        const contractNumber = immInvestmentFunds.getIn(['contractFund', 'contractNumber']);
        let operative;
        const consentElement = (<OKConsents placementId={HIRE_INITIAL_FUNDS_GDPR_PID} />);

        if (isSubscription) {
            operative = formatText('operatives-buyInvestmentFund');
            const currencyObject = {
                amount: immInvestmentFunds.getIn(['steps', 0, 'amount']),
                currency: immAccount.getIn(['balance', 'currency'])
            };

            operationParams = {
                originAccount: `${API_ENTERPRISE_NUMBER}${API_CENTER}${productNumber}${contractNumber}`,
                ammount: parseFloat(currencyObject.amount),
                currency: currencyObject.currency
            };
        } else {
            operative =  formatText('operatives-contractInevestmentFund');
            operationParams = {
                originAccount: `${API_ENTERPRISE_NUMBER}${API_CENTER}${productNumber}${contractNumber}`
            };
        }

        if (!isSubscription && !immInvestmentFunds.get('isFetchedPre') ||
            immInvestmentFunds.get('fetchingDocumentsValidate') ||
            immInvestmentFunds.get('fetchingEconomicReportValidation')) {
            return <LoadingSection />
        } else if (isSubscription && immInvestmentFunds.get('isFetchingPre')) {
            return <LoadingSection />
        } else if (isSubscription && immInvestmentFunds.get('fetchingDataExt')) {
            return <LoadingSection />
        } else {
            return (
                <div className="hire-alternative-investment-step2">
                    <header className="hire-alternative-investment-step2__header">
                        <h2 className="hire-alternative-investment-step2__title">
                            <FormattedText
                                value="brokerAlternativeFundsBuyStep2-title"
                                className="hire-alternative-investment-step2_description"
                            />
                        </h2>
                    </header>
                    <ContactCenterRender>
                        <ConfirmationScript operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING} />
                    </ContactCenterRender>
                    {!featureFlagShowExtantCostBuyFunds &&
                        <FormattedText
                            value="brokerAlternativeFundsBuyStep2-description"
                            className="hire-alternative-investment-step2__description"
                        />
                    }
                    {columnsContainer}
                    {consentElement}
                    {mifidDisclaimer}
                    <WebappRender>
                        <div className="row">
                            <div className="col-sm-12">
                                {this.renderDocumentationBox()}
                            </div>
                        </div>
                    </WebappRender>
                    <WebappRender>
                        <div className="hire-alternative-investment-step2__checkbox">
                            <div className="hire-alternative-investment-step2__checkbox__message">
                                {showDisclaimerErrorState &&
                                    <OKMessage type="warning">
                                        <FormattedText value="brokerAlternativeFundsBuyStep2-documentsRead" />
                                    </OKMessage>
                                }
                            </div>
                            {this.buildDisclaimerCheckbox()}
                        </div>
                    </WebappRender>
                    <ContactCenterRender>
                        <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                    </ContactCenterRender>
                    {showGDPRSignaturePattern &&
                        <div className="hire-alternative-investment-step2__signature-container">
                            <GDPRSignaturePattern
                                operationType={trxId}
                                operationParams={operationParams}
                                multiOTPMessageCode={BROKER_HIRE_INVESTMENT_FUND_AND_GDPR}
                                isWealth={true}
                            />
                        </div>
                    }
                </div>
            );
        }
    }
}

BrokerHireAlternativeInvestmentFundStep2.defaultProps = {
    owner: ''
};

BrokerHireAlternativeInvestmentFundStep2.propTypes = {
    fundId: PropTypes.string.isRequired,
    handleChangeAuth: PropTypes.func.isRequired,
    validateEconomicReport: PropTypes.func.isRequired,
    handleChangeReadChecked: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immInvestmentFunds: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    immBrokerMiFIDProducts: PropTypes.object.isRequired,
    postPreHire: PropTypes.func.isRequired,
    resetFetchedPre: PropTypes.func.isRequired,
    removeLegalDocumentation: PropTypes.func.isRequired,
    immFlagBasedFeatures: PropTypes.object,
    extantDataFetch: PropTypes.func,
    onStepChange: PropTypes.func,
    validateFundDocuments: PropTypes.func,
    immBrokerMyInvestments: PropTypes.object.isRequired,
};

module.exports.constructor = BrokerHireAlternativeInvestmentFundStep2;
module.exports.BrokerHireAlternativeInvestmentFundStep2 = connect(
    state => ({
        immBrokerMyInvestments: state.brokerMyInvestments,
        immBrokerConvenienceMiFIDTest: state.brokerConvenienceMiFIDTest,
        immBrokerMiFIDProducts: state.brokerMiFIDProducts,
        immLegalDocumentationProduct: state.brokerLegalDocumentation,
    }),
    {
        handleChangeAuth: investmentFundsActions.changeAuth,
        handleChangeReadChecked: investmentFundsActions.changeReadChecked,
        hireInvestment: investmentFundsActions.hireInvestment,
        postPreHire: investmentFundsActions.postPreHire,
        resetFetchedPre: investmentFundsActions.resetFetchedPre,
        validateEconomicReport: investmentFundsActions.validateEconomicReport,
        removeLegalDocumentation: brokerLegalDocumentationActions.removeLegalDocumentation,
        extantDataFetch: investmentFundsActions.postExtantCostsBuyFunds,
        validateFundDocuments: investmentFundsActions.validateFundDocuments,
    }
)(withRouter(BrokerHireAlternativeInvestmentFundStep2));
